import * as stylex from "@stylexjs/stylex";
import {
  spacing,
  colors,
  fontSizes,
} from "@softmax/design-system/tokens.stylex";
import { formatScore } from "@softmax/product-ux/play-values";
import type { DisplayEpisode } from "./episode-values";
import { styles } from "./episodes.styles";

function signedScore(delta: number): string {
  if (delta === 0) return "±0";

  return `${delta > 0 ? "+" : "−"}${formatScore(Math.abs(delta))}`;
}

export function EpisodeScore({
  row,
  narrow = false,
}: {
  readonly row: DisplayEpisode;
  readonly narrow?: boolean;
}) {
  if (!("mySeatRank" in row)) {
    return (
      <span {...stylex.props(styles.score, !narrow && styles.end)}>
        {formatScore(row.topScore)}
      </span>
    );
  }

  return (
    <span
      {...stylex.props(narrow ? localStyles.scoreInline : localStyles.scores)}
    >
      <span
        data-testid="episode-score"
        {...stylex.props(styles.score, styles.end)}
      >
        {formatScore(row.score)}
      </span>
      <span
        data-testid="episode-score-delta"
        {...stylex.props(localStyles.delta, styles.end)}
      >
        {signedScore(row.scoreDeltaVsMedian)}
        {narrow ? " vs median" : null}
      </span>
    </span>
  );
}

const localStyles = stylex.create({
  delta: {
    fontSize: fontSizes.caption,
    fontVariantNumeric: "tabular-nums",
    color: colors.muted,
  },
  scores: {
    display: "grid",
    gridTemplateColumns: "44px 46px",
    alignItems: "baseline",
    columnGap: spacing.space6,
    justifySelf: "end",
  },
  scoreInline: { display: "flex", alignItems: "baseline", gap: 6 },
});
